import React from 'react'
import { IconButton } from '@st-operations/uikit/src/v2/index.js'

import './styles.scss'
import ManageComponent from '../../../manage-component/index.jsx'

const CustomAttributesList = ({ list, onEdit, onDelete }) => {
  return (
    <div className="custom-attributes-list">
      <Choose>
        <When condition={list?.length > 0}>
          <For each="attribute" of={list} index="index">
            <div className="custom-attributes-list__item">
              <div className="custom-attributes-list__item-label">{attribute.alias}</div>
              <ManageComponent>
                <div className="custom-attributes-list__item-icons">
                  <IconButton
                    text="Edit"
                    className="manage-filter__button"
                    onClick={() => onEdit(index, attribute)}
                    iconProps={{ icon: 'edit', type: 'fill', width: 24, height: 24 }}
                  />
                  <IconButton
                    text="Delete"
                    className="manage-filter__button"
                    onClick={() => onDelete(index, attribute)}
                    iconProps={{ icon: 'trashcan', type: 'fill', width: 24, height: 24 }}
                  />
                </div>
              </ManageComponent>
            </div>
          </For>
        </When>
        <Otherwise>
          <p className="custom-attributes-list__empty">{`You haven't added any custom attributes yet.`}</p>
        </Otherwise>
      </Choose>
    </div>
  )
}

export default CustomAttributesList
